import * as actionTypes from '../../../constants/actionTypes';
import {getApiConfig} from "../../../utilities";
import {store} from "../../../main";
import {mergeFilterObjects} from "./filtersFunctions";
import {getAuthSubDomain, hardCodeIsFloForm} from "../../../constants/fabricatorHardcode";

export const toggleFeaturesFiltersVisible = (featuresFiltersVisible) => ({
  type: actionTypes.FEATURES_FILTERS_TOGGLE_FEATURES_FILTERS_VISIBLE,
  payload: {featuresFiltersVisible}
});

export const setFeaturesGroupAvailableFilters = (groupName, featuresFiltersArray) => ({
  type: actionTypes.FEATURES_FILTERS_SET_GROUP_AVAILABLE_FILTERS,
  payload: {groupName, filters: featuresFiltersArray}
});

//******** FILTER COMMANDS **********//
export const setSelectedFilters = (selectedFilters) => ({
  type: actionTypes.FEATURES_FILTERS_SET_SELECTED_FILTERS,
  payload: {selectedFilters}
});

export const setExpandedFilters = (expandedFilters) => ({
  type: actionTypes.FEATURES_FILTERS_SET_EXPANDED_FILTERS,
  payload: {expandedFilters}
});

export const setFilterVisible = (filterVisible) => ({
  type: actionTypes.FEATURES_FILTERS_SET_VISIBLE_FILTERS,
  payload: {filterVisible}
});

export const getAllFilterGroups = () => {
  store.dispatch({type: actionTypes.FEATURES_FILTERS_GET_ALL_AVAILABLE_FILTERS_REQUEST});
  const {auth, asCustomer} = store.getState();
  const fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
  return getApiConfig(`public/filterGroups`)
    .get()
    .then((response) => {
      store.dispatch({
        type: actionTypes.FEATURES_FILTERS_SET_ALL_AVAILABLE_FILTERS,
        payload: {
          allFilterGroups: response.sort((a, b) => (a.name > b.name) ? 1 : -1)
        }
      });
      return response
    })
};

const regexForLettersAndSpacesOnly = /^[a-zA-Z\s]*$/;

export const getFiltersListFromFeaturesArray = (dbFeaturesArray, totalFiltersList = [], subDomain = "") => {
  const hideMasterProfileFilters = hardCodeIsFloForm(subDomain);
  for (let i = 0; i < dbFeaturesArray.length; i++) {
    const disFeature = dbFeaturesArray[i];
    const featureFilterValueIds = mergeFilterObjects(disFeature, hideMasterProfileFilters);
    featureFilterValueIds.forEach(filterId => {
      if (!totalFiltersList.includes(filterId)) {
        totalFiltersList.push(filterId)
      }
    })
  }
  return totalFiltersList
}

export const getFilterValuesByGroup = (groupName, filterId = null, featuresSetupPage, forFabricatorId = null) => {
  if (!regexForLettersAndSpacesOnly.test(groupName)) {
    console.log("groupName contains invalid characters, no request for:", groupName);
    store.dispatch(setFeaturesGroupAvailableFilters(groupName, []));
    return Promise.resolve()
  }
  store.dispatch({type: actionTypes.FEATURES_FILTERS_GET_GROUP_AVAILABLE_FILTERS_REQUEST});
  const {auth, asCustomer, featuresCreatorNew, featuresSetupState} = store.getState();
  const fabricatorId = forFabricatorId || (asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId);
  let requestUrl =`public/bvdata/${fabricatorId}/filters/${groupName}/ALL/`;
  let requestUrlKitchen = requestUrl + "?mode=kitchen";
  if (filterId) {
    requestUrl = requestUrl + filterId
  }
  return Promise.all([getApiConfig(requestUrl).get(), getApiConfig(requestUrlKitchen).get()])
    .then((response) => {
      let filterValuesArray = [];
      response.forEach(responseArray => {
        if (Array.isArray(responseArray)) {
          filterValuesArray = [...filterValuesArray, ...responseArray]
        }
      });
      const arrayWithFeaturesToCheck = featuresSetupPage ? featuresSetupState.featuresList : featuresCreatorNew.disabledFeatures;
      if (Array.isArray(arrayWithFeaturesToCheck)) {
        const subDomain = getAuthSubDomain(auth, asCustomer);
        filterValuesArray = getFiltersListFromFeaturesArray(arrayWithFeaturesToCheck, filterValuesArray, subDomain)
      }
      store.dispatch(setFeaturesGroupAvailableFilters(groupName, filterValuesArray));
      return filterValuesArray
    })
};
